import { valueOf } from "@/types/common";

export const CASE_STATUS = {
  JOB_POSTED: 0,
  PREPARING_PROPOSAL: 1,
  PROPOSING_CANDIDATE: 2,
  INTERVIEWING: 3,
  OFFERED: 4,
  WAITING_FOR_JOINING: 5,
  RECRUITMENT_STOPPED: 6,
} as const;

export type TCaseStatus = valueOf<typeof CASE_STATUS>;

export const CASE_STATUS_LABEL: Record<keyof typeof CASE_STATUS, string> = {
  JOB_POSTED: "求人情報登録",
  PREPARING_PROPOSAL: "人材推薦準備中",
  PROPOSING_CANDIDATE: "人材推薦中",
  INTERVIEWING: "面接選考中",
  OFFERED: "内定",
  WAITING_FOR_JOINING: "入社待ち",
  RECRUITMENT_STOPPED: "募集終了",
};
